export const MEETINGS_NAMESPACE = "meetings";
